import { FC } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { pageAnimation } from '@const/animation';
import illustration from '@svg/illustrations/success_mfa_app.svg';
import { motion } from 'framer-motion';
import Typography from '@components/common/typography';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
}

const Success: FC<IProps> = ({ onSubmit }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.main_wrapper}>
            <motion.div {...pageAnimation} className={styles.wrapper}>
                <img src={illustration} alt="illustration" />
                <div className={styles.text_wrapper}>
                    <Typography alignment="center" variant="h3" className={styles.title}>
                        Success!
                    </Typography>
                    <Typography alignment="center" variant="body3" className={styles.description}>
                        Your authenticator app is now connected to your XEPPT account and set as
                        your 2FA method. The next time you sign in, you’ll need to enter a
                        verification code from your app.
                    </Typography>
                </div>
                <div className={styles.actions}>
                    <Button variant="primary" onClick={onSubmit}>
                        {submitLocale('done')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default Success;
